import { routeName } from "../routes/routers-name";
import { icons } from "./images";


export enum MENUS_FIRST {
    EMPLOYEES = 'EMPLOYEES',
    ROLE = 'ROLE',
    DEPARTMENT = 'DEPARTMENT',
    POSITION = 'POSITION',
}

export const defaultMenu: any = {
    HOME: { key: 'HOME', name: 'Home', textName: 'Home', active: false, path: routeName.home },
}

export const menuFirsts: any = {
    EMPLOYEES: { key: 'EMPLOYEES', name: 'Employees', code: 'Employees.Read', textName: 'จัดการผู้ใช้งาน', icon: <icons.barDrawer />, active: false, path: routeName.employees,},
    ROLE: { key: 'ROLE', name: 'Role', code: 'Role.Read', textName: 'จัดการบทบาท', icon: <icons.securityDrawer />, active: false, path: routeName.role },
    DEPARTMENT: { key: 'DEPARTMENT', name: 'Department', code: 'Department.Read', textName: 'จัดการหน่วยงาน', icon: <icons.securityDrawer />, active: false, path: routeName.department },
    POSITION: { key: 'POSITION', name: 'Position', code: 'Position.Read', textName: 'จัดการตำแหน่ง', icon: <icons.securityDrawer />, active: false, path: routeName.position },
}

export const menuSeconds: any = {
    EMPLOYEES: { key: 'EMPLOYEES', name: 'employees', textName: 'จัดการผู้ใช้งาน', icon: <icons.barDrawer />, active: false, path: routeName.employees },
    ROLE: { key: 'ROLE', name: 'role', textName: 'จัดการบทบาท', icon: <icons.securityDrawer />, active: false, path: routeName.role },
}
